import React from "react";
import "assets/styles/device/BenefitsDevice.scss";

const BenefitsDevice = () => {
  const steps = [
    {
      number: 1,
      title: "¡Iniciemos!",
      description: "Agendamos una llamada para conocer a detalle las necesidades de tu negocio.",
      hasEmoji: true
    },
    {
      number: 2,
      title: "KYC",
      description: "Envía tus documentos y proyecciones a comercial@etomin.com",
      hasEmoji: false
    },
    {
      number: 3,
      title: "Propuesta",
      description: "Recibe y aprueba una propuesta comercial",
      hasEmoji: false
    },
    {
      number: 4,
      title: "Contrato",
      description: "Recibe y firma el contrato con Etomin",
      hasEmoji: false
    },
    {
      number: 5,
      title: "Terminales",
      description: "Recibe tu(s) terminal(es)",
      hasEmoji: false
    },
    {
      number: 6,
      title: "Panel",
      description: "Recibe los accesos al panel para monitorear los pagos de tus clientes",
      hasEmoji: false
    },
    {
      number: 7,
      title: "Capacitación",
      description: "Recibe una capacitación para el uso de tus terminales y panel",
      hasEmoji: false
    },
    {
      number: 8,
      title: "Bienvenido",
      description: "¡Acepta pagos en cualquier lugar!",
      hasEmoji: true
    }
  ];

  return (
    <div className={'benefitsDeviceWrapper'}>
      <div className={'benefitsDevice'}>
        <div className={'processFlow'}>
          {/* Primera fila: pasos 1-4 */}
          <div className={'processRow'}>
            {steps.slice(0, 4).map((step, index) => (
              <div key={step.number} className={'processStep'}>
                <h3 className={'processStepTitle'}>{step.title}</h3>
                <div className={'processStepNumber'}>{step.number}</div>
                <div className={'processStepBox'}>
                  <p>{step.description}</p>
                  {step.hasEmoji && <div className={'processEmoji'}>😊</div>}
                </div>
              </div>
            ))}
          </div>

          {/* Segunda fila: pasos 8-5 (invertido) */}
          <div className={'processRow processRowReverse'}>
            {steps.slice(4, 8).reverse().map((step, index) => (
              <div key={step.number} className={'processStep'}>
                <h3 className={'processStepTitle'}>{step.title}</h3>
                <div className={'processStepNumber'}>{step.number}</div>
                <div className={'processStepBox'}>
                  <p>{step.description}</p>
                  {step.hasEmoji && <div className={'processEmoji'}>😊</div>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenefitsDevice;
